import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';

import Text from '~/components/Text';

import Icon from '../Icon/Icon';
import { IconTypes } from '../Icon/IconTypes';

import styles from './HeaderIconBanner.module.scss';

type BannerVariant = 'gradient' | 'gray';

interface HeaderIconBannerProps {
  title: string;
  subtitle: string;
  icon?: IconTypes;
  imageSrc?: string;
  imageAlt?: string;
  variant?: BannerVariant;
  className?: string;
  onClick?: () => void;
  ariaExpanded?: boolean;
  endIcon?: IconTypes;
  endIconClassName?: string;
}

const HeaderIconBanner = ({
  icon,
  imageSrc,
  imageAlt = '',
  title,
  subtitle,
  variant = 'gradient',
  className,
  onClick,
  ariaExpanded,
  endIcon,
  endIconClassName,
}: HeaderIconBannerProps) => {
  const isImage = Boolean(imageSrc);
  const showIcon = !isImage && icon;

  return (
    <div
      className={classes([
        styles.root,
        variant === 'gray' ? styles.gray : styles.gradient,
        className,
      ])}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-expanded={onClick ? ariaExpanded : undefined}
      onClick={onClick}
    >
      {isImage ? (
        <img src={imageSrc} alt={imageAlt} className={styles.image} />
      ) : showIcon ? (
        <div className={styles.iconWrapper}>
          <Icon type={icon} size={24} />
        </div>
      ) : null}

      <div className={styles.rightSection}>
        <Text className={styles.title}>{title}</Text>
        <Text className={styles.secondaryText}>{subtitle}</Text>
      </div>
      {endIcon && (
        <div className={classes([styles.endIcon, endIconClassName])}>
          <Icon type={endIcon} size={20} />
        </div>
      )}
    </div>
  );
};

export default observer(HeaderIconBanner);
